var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('van-image',{staticStyle:{"width":"100%","max-height":"100vh"},attrs:{"src":_vm.nullPageOne}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }